import dayjs, {type Dayjs} from "dayjs";

export const DecFloor = (value?: number, casas: number = 2) => {
    if (value == null) return undefined;
    return Math.floor(value * Math.pow(10, casas)) / Math.pow(10, casas);
};

export const DecCeil = (value?: number, casas: number = 2) => {
    if (value == null) return undefined;
    return Math.ceil(value * Math.pow(10, casas)) / Math.pow(10, casas);
};

export const DecEqual = (a?: number, b?: number, casas: number = 2) => {
    if (a == null || b == null) return undefined;

    return DecCeil(a, casas) == DecCeil(b, casas);
};

export const ToMoney = (value?: number | null, abs?: boolean) => {
    if (value == null) return undefined;
    if (abs) value = Math.abs(value);

    return Number(value).toLocaleString("pt-br", {
        style: 'currency',
        currency: 'brl',
    });
};

export function ToInt(value: number | undefined | string): number;
export function ToInt(value: number | undefined | string, config: undefined | {
    allowUndefined: false
}): number ;
export function ToInt(value: number | undefined | string, config: undefined | {
    allowUndefined: true
}): number | undefined;
export function ToInt(value?: number | undefined | string, config: undefined | {
    allowUndefined: boolean
} = undefined): number | undefined {
    value = RemoveNonNumeric(value);
    const allowUndefined = config?.allowUndefined == true || config == null

    if (value == null || value == '') return allowUndefined ? undefined : 0;

    return Math.floor(Number(value));
}

export function RemoveNonNumeric(value?: number | string): number | string {
    if (value == null) return 0;

    return value.toString().replace(/[^0-9]/g, '');
}

export function OnlyNumeric(value?: number | string): number
export function OnlyNumeric(value?: number | string, options?: { type: 'number' }): number
export function OnlyNumeric(value?: number | string, options?: { type: 'string' }): string
export function OnlyNumeric(value?: number | string, options?: { type: 'number' | 'string' }): number | string {
    if (value == null) return '';

    switch (options?.type) {
        case 'number':
            return Number(value.toString().replace(/[^0-9]/g, ''));
        case 'string':
            return value.toString().replace(/[^0-9]/g, '');
        default:
            return value.toString().replace(/[^0-9]/g, '');
    }
}

export const ToDate = (value?: Date | Dayjs | string, format?: boolean | string) => {
    if (value != null) {
        const date = dayjs(value);
        if (format) {
            if (format === true) {
                return date.format('DD/MM/YYYY');
            } else if (typeof format === 'string') {
                return date.format(format);
            }
        }

        return date;
    }

    return undefined;
};

export const ToDateString = (value?: Date | Dayjs | string, format?: boolean | string) => {
    return ToDate(value, format) as string | undefined;
};

export const ToDateDefault = (value?: Date | Dayjs | string): string | undefined => {
    return ToDate(value, true) as string;
};

export const ToDateTimeDefault = (value?: Date | Dayjs | string): string | undefined => {
    return ToDate(value, 'DD/MM/YYYY HH:mm') as string;
}

export function clamp(value: number, min: number, max: number) {
    return Number(Math.min(Math.max(value, min), max))
}